// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const blacksmith = defineModel({
  id: "blacksmith",
  batchId: "future",
  name: "Blacksmith",
  tags: ["building","blacksmith","low-poly","age-of-mcp","future"],
  summary: "Forges ingots and plank into tools — used in many builds and jobs.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.28, 0.12), color: "#6e6a64", position: [0, 0.28, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.28, 0.66), color: "#6e6a64", position: [-0.33, 0.28, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, 0.42] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.56, 0.12), color: "#6e6a64", position: [0, 0.42, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.56, 0.66), color: "#6e6a64", position: [-0.33, 0.42, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, 0.42] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.58, 0.12), color: "#6e6a64", position: [0, 0.43, -0.33] },
      { geometry: new THREE.BoxGeometry(0.12, 0.58, 0.66), color: "#6e6a64", position: [-0.33, 0.43, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.532541), color: "#5e3a24", position: [0, 0.87, 0.22], rotation: [0.598419, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.532541), color: "#5e3a24", position: [0, 0.87, -0.22], rotation: [-0.598419, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.96, 0.07, 0.07), color: "#3f2616", position: [0, 1.02, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.24, 0.26), color: "#6e6a64", position: [-0.18, 0.26, -0.18] },
      { geometry: new THREE.BoxGeometry(0.18, 0.1, 0.18), color: "#ff7a2e", position: [-0.18, 0.38, -0.18] },
      { geometry: new THREE.BoxGeometry(0.26, 0.2, 0.22), color: "#6e6a64", position: [-0.18, 0.58, -0.24] },
      { geometry: new THREE.BoxGeometry(0.16, 0.66, 0.16), color: "#6e6a64", position: [-0.18, 0.92, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.11, 0.18, 9), color: "#7a5530", position: [0.18, 0.23, 0.06] },
      { geometry: new THREE.BoxGeometry(0.2, 0.05, 0.1), color: "#33363a", position: [0.18, 0.35, 0.06] },
      { geometry: new THREE.BoxGeometry(0.1, 0.06, 0.08), color: "#33363a", position: [0.18, 0.29, 0.06] },
      { geometry: new THREE.ConeGeometry(0.04, 0.1, 6), color: "#33363a", position: [0.3, 0.35, 0.06], rotation: [0, 0, -1.570796] },
      { geometry: new THREE.BoxGeometry(0.24, 0.12, 0.14), color: "#6e4a28", position: [0.16, 0.2, 0.3] },
      { geometry: new THREE.BoxGeometry(0.2, 0.02, 0.1), color: "#2c5a6a", position: [0.16, 0.26, 0.3] },
      { geometry: new THREE.BoxGeometry(0.3, 0.03, 0.03), color: "#6e4a28", position: [0.16, 0.58, -0.27] },
      { geometry: new THREE.BoxGeometry(0.02, 0.18, 0.02), color: "#33363a", position: [0.08, 0.49, -0.27] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.02), color: "#33363a", position: [0.08, 0.39, -0.27] },
      { geometry: new THREE.BoxGeometry(0.02, 0.2, 0.02), color: "#33363a", position: [0.22, 0.48, -0.27] },
    ] },
  ],
  animations: [],
});
